import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { ConfigService } from '../../../../core';
import { ConfigPedido, ConfigPedidoUtilsService } from '../../../configuracoes/app/pedido';
import { pedidoAbertoERP, pedidoAprovado, pedidoCancelado, pedidoConfirmado, pedidoConfirmandoERP, pedidoEmAnalise, pedidoFaturado, pedidoFaturadoParcial, pedidoNaoConfirmado, pedidoNaoLiberado, pedidoProducao, pedidoReprovado, pedidoStatusOutro } from '../pedido-status';

@Component({
    selector: 'sgt-pedido-status-multiselect',
    templateUrl: './pedido-status-multiselect.component.html',
    styleUrls: ['./pedido-status-multiselect.component.less']
})
export class PedidoStatusMultiselectComponent implements OnInit {
    configPedido: ConfigPedido;

    /** Status selecionados */
    @Input() status: number[];
    /** Ao alterar a seleção dos status */
    @Output() statusChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Status';
    @Input() checked = 'Status'
    @Input() checkedPlural = 'Status';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum status encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    @Input() isShowNaoConfirmado = true;
    @Input() isShowNaoLiberado = true;
    @Input() isShowConfirmado = true;
    @Input() isShowEmAnalise = true;
    @Input() isShowAprovado = true;
    @Input() isShowReprovado = true;
    @Input() isShowProducao = true;
    @Input() isShowFaturado = true;
    @Input() isShowFaturadoParcial = true;
    @Input() isShowConfirmandoERP = true;
    @Input() isShowAbertoERP = true;
    @Input() isShowOutro = true;
    @Input() isShowCancelado = true;

    // Options
    options: IMultiSelectOption[];

    constructor(private configService: ConfigService,
                private configPedidoUtilsService: ConfigPedidoUtilsService) { }

    ngOnInit() {
        this.configPedido = this.configService.getPedido();

        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-pedido-status ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os status para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        // Não Confirmado
        if (this.configPedidoUtilsService.possuiStatus(this.configPedido, pedidoNaoConfirmado) && this.isShowNaoConfirmado) {
            selects.push({
                id: pedidoNaoConfirmado.id,
                name: pedidoNaoConfirmado.nome,
                classes: 'multiselect-item-pedido-status multiselect-item-pedido-status-nao-confirmado'
            });
        }

        // Não Liberado
        if (this.configPedidoUtilsService.possuiStatus(this.configPedido, pedidoNaoLiberado) && this.isShowNaoLiberado) {
            selects.push({
                id: pedidoNaoLiberado.id,
                name: pedidoNaoLiberado.nome,
                classes: 'multiselect-item-pedido-status multiselect-item-pedido-status-nao-liberado'
            });
        }

        // Confirmado
        if (this.configPedidoUtilsService.possuiStatus(this.configPedido, pedidoConfirmado) && this.isShowConfirmado) {
            selects.push({
                id: pedidoConfirmado.id,
                name: pedidoConfirmado.nome,
                classes: 'multiselect-item-pedido-status multiselect-item-pedido-status-confirmado'
            });
        }

        // Confirmado ERP
        if (this.configPedidoUtilsService.possuiStatus(this.configPedido, pedidoConfirmandoERP) && this.isShowConfirmandoERP) {
            selects.push({
                id: pedidoConfirmandoERP.id,
                name: pedidoConfirmandoERP.nome,
                classes: 'multiselect-item-pedido-status multiselect-item-pedido-status-confirmando-erp'
            });
        }

        // Aberto ERP
        if (this.configPedidoUtilsService.possuiStatus(this.configPedido, pedidoAbertoERP) && this.isShowAbertoERP) {
            selects.push({
                id: pedidoAbertoERP.id,
                name: pedidoAbertoERP.nome,
                classes: 'multiselect-item-pedido-status multiselect-item-pedido-status-aberto-erp'
            });
        }

        // Em Análise
        if (this.configPedidoUtilsService.possuiStatus(this.configPedido, pedidoEmAnalise) && this.isShowEmAnalise) {
            selects.push({
                id: pedidoEmAnalise.id,
                name: pedidoEmAnalise.nome,
                classes: 'multiselect-item-pedido-status multiselect-item-pedido-status-em-analise'
            });
        }

        // Aprovado
        if (this.configPedidoUtilsService.possuiStatus(this.configPedido, pedidoAprovado) && this.isShowAprovado) {
            selects.push({
                id: pedidoAprovado.id,
                name: pedidoAprovado.nome,
                classes: 'multiselect-item-pedido-status multiselect-item-pedido-status-aprovado'
            });
        }

        // Reprovado
        if (this.configPedidoUtilsService.possuiStatus(this.configPedido, pedidoReprovado) && this.isShowReprovado) {
            selects.push({
                id: pedidoReprovado.id,
                name: pedidoReprovado.nome,
                classes: 'multiselect-item-pedido-status multiselect-item-pedido-status-reprovado'
            });
        }

        // Produção
        if (this.configPedidoUtilsService.possuiStatus(this.configPedido, pedidoProducao) && this.isShowProducao) {
            selects.push({
                id: pedidoProducao.id,
                name: pedidoProducao.nome,
                classes: 'multiselect-item-pedido-status multiselect-item-pedido-status-producao'
            });
        }

        // Faturado
        if (this.configPedidoUtilsService.possuiStatus(this.configPedido, pedidoFaturado) && this.isShowFaturado) {
            selects.push({
                id: pedidoFaturado.id,
                name: pedidoFaturado.nome,
                classes: 'multiselect-item-pedido-status multiselect-item-pedido-status-faturado'
            });
        }

        // Faturado Parcial
        if (this.configPedidoUtilsService.possuiStatus(this.configPedido, pedidoFaturadoParcial) && this.isShowFaturadoParcial) {
            selects.push({
                id: pedidoFaturadoParcial.id,
                name: pedidoFaturadoParcial.nome,
                classes: 'multiselect-item-pedido-status multiselect-item-pedido-status-faturado-parcial'
            });
        }

        // Cancelado
        if (this.configPedidoUtilsService.possuiStatus(this.configPedido, pedidoCancelado) && this.isShowCancelado) {
            selects.push({
                id: pedidoCancelado.id,
                name: pedidoCancelado.nome,
                classes: 'multiselect-item-pedido-status multiselect-item-pedido-status-cancelado'
            });
        }

        // Outro
        if (this.configPedidoUtilsService.possuiStatus(this.configPedido, pedidoStatusOutro) && this.isShowOutro) {
            selects.push({
                id: pedidoStatusOutro.id,
                name: pedidoStatusOutro.nome,
                classes: 'multiselect-item-pedido-status multiselect-item-pedido-status-outro'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção dos status */
    onChange() {
        this.statusChange.emit(this.status);
    }
}
